import i18n from "i18next";
import Backend from "i18next-http-backend";
import LanguageDetector from "i18next-browser-languagedetector";
import { initReactI18next } from "react-i18next";

i18n
  .use(Backend) // Load translation using HTTP backend
  .use(LanguageDetector) // Detect user language
  .use(initReactI18next) // Pass i18n instance to react-i18next
  .init({
    fallbackLng: "en", // Default language if detection fails
    load: "languageOnly",
    debug: false, // Enable debug mode for development
    backend: {
      loadPath: "/locales/{{lng}}.json", // Path to load translations
    },
    interpolation: {
      escapeValue: false, // React already escapes by default
    },
    react: {
      useSuspense: false, // Disable suspense if not using React Suspense
    },
  });

export default i18n;
